import { Expose } from 'class-transformer';
import { DropdownModel } from '../../shared-features/models/dropdown-model';
import { UserRole } from '@shared/enums/user-role.enum';
import { UserType } from '@shared-features/enums/user-type.enum';

export class Role extends DropdownModel {
  @Expose() id: number;
  @Expose() name: string = '';
  @Expose() isDefault: boolean;
  @Expose() isActive: boolean;
  @Expose() createdAt: number;
  @Expose() updatedAt: number;
  @Expose() userRole?: UserRole;
  @Expose() userType?: UserType;
  constructor() {
    super();
  }

  get dropDownDisplayName(): string {
    return this.name;
  }
  get dropDownValue(): Object {
    return this;
  }
}
